export default "/assets/maintain.svg";